<template>
    <v-expand-transition>
        <div v-if="suggestedAddress !== null && suggestedAddress !== ''">
            <div class="suggestion-container" style="width: 100% !important; margin-bottom: 30px">
                <div class="d-flex">
                    <v-icon class="mr-2" color="warning">info</v-icon>
                    <div class="mt-auto mb-auto">
                        <b style="font-size: 18px;">Différence détectée</b>
                    </div>
                </div>

                <div class="mt-3">
                    Une nouvelle adresse a été détectée sur Google : <b>{{ suggestedAddress }}</b>
                </div>

                <div class="d-flex justify-content-center flex-wrap mt-4 mb-2">
                    <v-btn class="text-none mr-5"
                           color="warning"
                           large
                           style="border-radius: 25px; border-width: 2px; font-weight: bold"
                           outlined
                           @click="setAddress()">
                        Modifier cette adresse
                    </v-btn>

                    <v-btn class="text-none ml-5"
                           text
                           color="#ffa533"
                           style="font-size: 16px"
                           @click="removeAddressSuggestion()">
                        Ignorer
                    </v-btn>
                </div>
            </div>
        </div>
    </v-expand-transition>
</template>

<script>
import {mapState, mapMutations} from "vuex"
export default {
    name: "AddressSuggestion",
    computed: {
        ...mapState('web_form', ['provider', 'suggestedAddress'])
    },
    methods: {
        ...mapMutations('web_form', ['setSuggestedAddress']),
        setAddress() {
            this.provider.localisation.address = this.suggestedAddress

            this.setSuggestedAddress(null)
        },
        removeAddressSuggestion() {
            this.setSuggestedAddress(null)
        }
    }
}
</script>

